import { render, staticRenderFns } from "./floor-multi-sector.vue?vue&type=template&id=0fc9b0b2&scoped=true"
import script from "./floor-multi-sector.vue?vue&type=script&lang=js"
export * from "./floor-multi-sector.vue?vue&type=script&lang=js"
import style0 from "./floor-multi-sector.vue?vue&type=style&index=0&id=0fc9b0b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc9b0b2",
  null
  
)

export default component.exports